import { api_get, api_post } from "service/api";
import { toast } from "react-toastify";
import { Toast } from "components/Toast/Toast";

import * as types from './actionsTypes'

async function resolvedInvoice(dispatch, date, rfc, invoiceKey, folio) {
   const url = `${process.env.REACT_APP_URL}/invoices?date=${date}&rfc=${rfc}&invoiceKey=${invoiceKey}&folio=${folio}&qid=${process.env.REACT_APP_QID_TEST}`;
   try {
      dispatch({ type: types.LOADING_DATA })
      const auth = { headers: { authorization: `${process.env.REACT_APP_TOKEN_TEST}` } };
      const res = await api_get(url, auth)
      dispatch({
         type: types.SUCCESSED_DATA, payload: {
            data: res,
            origin: {
               date,
               invoiceKey,
               folio,
            }
         }
      });
   } catch (error) {
      dispatch({ type: types.FAILED_DATA, payload: error });
      toast.error(<Toast message={error} />, { theme: 'colored' })
   }
}

async function resolvedStamp(dispatch, body) {
   const origin = process.env.REACT_APP_ORIGIN
   const url = `${process.env.REACT_APP_URL}/invoices/income?&qid=${process.env.REACT_APP_QID_TEST}&origin=${origin}`;
   try {
      dispatch({ type: types.LOADING_STAMP })
      const auth = { headers: { authorization: `${process.env.REACT_APP_TOKEN_TEST}` } };
      const res = await api_post(url, body, auth)
      dispatch({ type: types.SUCCESSED_STAMP, payload: res });
   } catch (error) {
      dispatch({ type: types.FAILED_STAMP, payload: error });
      toast.error(<Toast message={error} />, { theme: 'colored' })
   }
}

function resetLoadedData(dispatch) {
   dispatch({
      type: types.RESET_LOADED_DATA
   })
}

function resetLoadedStamp(dispatch) {
   dispatch({
      type: types.RESET_LOADED_STAMP
   })
}


export {
   resolvedInvoice,
   resolvedStamp,
   resetLoadedData,
   resetLoadedStamp,
}